/**
 * Create new article card social custom element.
 */
class ArticleCardSocial extends HTMLElement {

  /**
   * Custom element constructor.
   */
  constructor() {
    super()
  }

  connectedCallback() {
    this.initializeElements();
    this.setupEventListeners();
  }

  initializeElements() {
    this.elements = {
      socialTrigger: this.querySelector('[data-article-card-social="trigger"]'),
    }
  }

  setupEventListeners() {
    const { socialTrigger } = this.elements;

    socialTrigger.addEventListener('click', this.displaySocialIcons.bind(this));
  }

  displaySocialIcons(event) {
    if (window.innerWidth > 750) {
      return
    }

    event.target.classList.toggle('active');
  }
}

if (!customElements.get('article-card-social')) {
  customElements.define('article-card-social', ArticleCardSocial)
}
